import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { l as label, i as input, b as inputInvalid, c as inputDisabled, d as inputFocused } from './parts.js';
import { F as FormControlErrorText } from './form-control-error-text.js';
import './details.js';
import { d as defineCustomElement$2 } from './custom-popper2.js';
import { d as defineCustomElement$1 } from './form-control-tooltip2.js';

const FileInput = /*@__PURE__*/ proxyCustomElement(class FileInput extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.formControlInput = createEvent(this, "formControlInput", 7);
        this.formControlBlur = createEvent(this, "formControlBlur", 7);
        this.fileSelected = createEvent(this, "fileSelected", 7);
        this.handleFormControlInput = (event) => {
            const target = event.target;
            const name = target.getAttribute('name');
            this.inputHandler(name, target.value);
            this.formControlInput.emit({ name, value: target.value });
        };
        this.changeHandler = () => {
            const inputFileList = this.fileInput.files;
            if (inputFileList) {
                this.fileSelected.emit({
                    fileList: inputFileList,
                    document_type: this.documentType
                });
            }
        };
        this.files = undefined;
        this.fileString = undefined;
        this.isFocused = false;
        this.label = undefined;
        this.name = undefined;
        this.helpText = undefined;
        this.errorText = undefined;
        this.multiple = undefined;
        this.documentType = undefined;
        this.inputHandler = undefined;
        this.disabled = undefined;
    }
    componentDidLoad() {
        this.fileInput = this.el.querySelector('input');
    }
    get part() {
        let part = input;
        if (this.errorText) {
            part = inputInvalid;
        }
        if (this.disabled) {
            part = inputDisabled;
        }
        if (this.isFocused) {
            part = inputFocused;
        }
        return part;
    }
    render() {
        return (h(Host, { key: '4950c97a276963d0b666313b5eb2047cd05ffe0f' }, h("div", { key: 'f09de9c091824da6e385e9129c007ea3ddefea7a', class: "form-group d-flex flex-column" }, h("div", { key: 'c853c5997df0a9a3b0789712abcbf25c1bc50884', class: "d-flex align-items-start gap-2" }, h("label", { key: 'e5c17b93898fdf7e2244f3a5549fdd3ddcc2bab8', part: label, class: "form-label", htmlFor: this.name }, this.label), h("form-control-tooltip", { key: '131ac4f66a6bae82f53473f36448780090f28a71', helpText: this.helpText })), h("input", { key: 'cf8374ebefcbe18b73d853c96b703652869ea0af', ref: (el) => this.fileInput = el, type: "file", name: this.name, part: this.part, class: this.errorText ? "form-control is-invalid" : "form-control", multiple: this.multiple, disabled: this.disabled, onChange: this.changeHandler, onInput: this.handleFormControlInput, onFocus: () => this.isFocused = true, onBlur: () => {
                this.isFocused = false;
                this.formControlBlur.emit();
            } }), h(FormControlErrorText, { key: 'd5ac4a7e8b5f70fd0cb63e9358bb372a3167ab5e', errorText: this.errorText, name: this.name }))));
    }
    get el() { return this; }
}, [0, "form-control-file", {
        "label": [1],
        "name": [8],
        "helpText": [1, "help-text"],
        "errorText": [1, "error-text"],
        "multiple": [4],
        "documentType": [1, "document-type"],
        "inputHandler": [16],
        "disabled": [4],
        "files": [32],
        "fileString": [32],
        "isFocused": [32]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["form-control-file", "custom-popper", "form-control-tooltip"];
    components.forEach(tagName => { switch (tagName) {
        case "form-control-file":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, FileInput);
            }
            break;
        case "custom-popper":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "form-control-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { FileInput as F, defineCustomElement as d };
